import {BookOpen} from 'lucide-react';
import {KnowledgeEditorController} from '../../hooks/useKnowledgeEditor';
import {KnowledgeMode} from '../../types';
import {Btn, Spinner} from '../Shared';
import {Dialog, DialogContent, DialogTitle, DialogDescription} from '../ui/dialog';
import {KnowledgeFields, KnowledgeUpload} from './KnowledgeFields';
import {UploadStatus} from './UploadStatus';

const modes: Array<[KnowledgeMode, string]> = [['text', 'Write an article'], ['upload', 'Upload a document']];
const EditorTabs = ({editor}: {editor: KnowledgeEditorController}) => {
  if (editor.editing) return null;
  return <div className="modal-tabs">{modes.map(([mode, label]) => <button key={mode} className={editor.mode === mode ? 'active' : ''} onClick={() => editor.setMode(mode)} data-testid={`knowledge-mode-${mode}`}>{label}</button>)}</div>;
};

function submitLabel(editor: KnowledgeEditorController): string {
  if (editor.progress?.phase === 'uploading') return 'Uploading…';
  if (editor.progress?.phase === 'processing') return 'Processing…';
  if (editor.busy) return 'Saving…';
  return editor.editing ? 'Save changes' : 'Add knowledge';
}

const EditorFooter = ({editor}: {editor: KnowledgeEditorController}) => <div className="form-footer knowledge-editor-footer">
  <Btn type="button" disabled={editor.busy} onClick={() => editor.changeOpen(false)} data-testid="knowledge-cancel">Cancel</Btn>
  <Btn type="submit" className="primary" disabled={editor.busy} data-testid="knowledge-submit">{editor.busy ? <Spinner/> : <BookOpen size={14}/>} {submitLabel(editor)}</Btn>
</div>;

export const KnowledgeEditor = ({editor}: {editor: KnowledgeEditorController}) => <Dialog open={editor.open} onOpenChange={editor.changeOpen}>
  <DialogContent className="app-modal knowledge-modal" data-testid="knowledge-modal">
    <DialogTitle data-testid="knowledge-modal-title">{editor.editing ? 'Edit knowledge' : 'Add to your knowledge base'}</DialogTitle>
    <DialogDescription data-description="true" data-testid="knowledge-modal-description">{editor.editing?.is_sample ? 'This sample article only applies to sample tickets.' : 'Approved facts and policies for grounded customer replies.'}</DialogDescription>
    <EditorTabs editor={editor}/>
    <form className="knowledge-editor-form" onSubmit={editor.submit}>
      <div className="knowledge-form-fields" data-testid="knowledge-scrollable-fields">
        {editor.mode === 'text' ? <KnowledgeFields editor={editor}/> : <KnowledgeUpload onFile={editor.setFile}/>}
        <UploadStatus progress={editor.progress}/>
        {editor.error && <div className="error-notice" role="alert" data-testid="knowledge-form-error">{editor.error}</div>}
      </div>
      <EditorFooter editor={editor}/>
    </form>
  </DialogContent>
</Dialog>;